// src/components/Footer.tsx
import React from "react";

import PCIDSS from "../../assets/images/PISDDBlack.svg"
import isoLogo from "../../assets/images/ISOBlack.svg"
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="">
         <div className='flex gap-20' style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            {/* <a href="https://seal.panaceainfosec.com/index.php?certid=CERT8FF97A4A3A" target='_blank'>
              <img src={PCIDSS} alt="PCI DSS logo" style={{width:"120px", marginBottom:"0"}} />
            </a>
            <a href="https://cerificateiso.s3.ap-south-2.amazonaws.com/Webetechies+Private+Limited.+ISO+CERTIFICATE.pdf" target='_blank'>
              <img src={isoLogo} alt="ISO logo" style={{width:"60px", marginBottom:"0"}} />
            </a>
        */}
       
          </div>
      <p>© {new Date().getFullYear()} <a href="https://webetechies.com/">Webetechies private limited</a>. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
